import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/imagenes/maestro1.png")